import { completeStage, selectStage } from '../../redux/slices/stageSlice';
import {
	display,
	displayToast,
	fetchPropertyInfo,
	selectSession,
	clearError,
} from '../../redux/slices/sessionSlice';
import {
	clear as documentClear,
	resetPostComplete as resetDocumentPostComplete,
	resetFaceVerificationComplete,
	selectDocuments,
	verifyFaceImage,
	clearError as clearDocumentError,
} from '../../redux/slices/documentSlice';
import {
	fetchProfile,
	clear as profileClear,
	resetPostComplete as resetProfilePostComplete,
	selectProfile,
	setCurrentProfile,
	updateProfileID,
} from '../../redux/slices/profileSlice';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hook';

import DocuSubmissionHome from '../../app/docu_submission/page';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GuestProfileFormHome from '../../app/guest-profile-form/page';
import {
	clear as ImageClear,
	popDocumentNumber,
} from '../../redux/slices/documentSlice';
import LivenessVerificationHome from '../../app/liveness-check/page';
import Loading from '../../components/loading';
import Swal from 'sweetalert2';
import useState from 'react-usestateref';
import { useTranslation } from 'react-i18next';

export const DocumentLivenessVerification = () => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const { stages, stage: currStage } = useAppSelector(selectStage);
	const {
		token,
		reservation,
		profiles,
		propertyInfo,
		documentMetaData,
		settings,
	} = useAppSelector(selectSession);
	const {
		isPostComplete: isDocumentPostComplete,
		isFaceVerificationComplete,
		isFaceVerificationError,
		error: documentError,
		guid,
		lastName,
		docTypeDescription,
		isUploadingPassport,
	} = useAppSelector(selectDocuments);

	console.log('selectDocuments === ' + guid);

	const { isPostComplete: isProfilePostComplete } =
		useAppSelector(selectProfile);
	const undoneProfiles = profiles?.map((profile: any) => {
		return profile?.isDocVerified && profile?.isFaceMatched ? profile : null;
	});
	const numOfKnownProfiles = profiles?.length;

	const enableChildScan = settings?.find(
		(setting: any) =>
			setting.parameterName === 'EnableChildScan' &&
			setting.parameterValue?.toLowerCase() === 'true'
	);
	const totalNumOfProfiles =
		reservation?.AdultCount +
		(enableChildScan ? reservation?.ChildCount ?? 0 : 0) -
		(numOfKnownProfiles - undoneProfiles?.length);
	const { currentProfile, profileID } = useAppSelector(selectProfile);
	// const totalNumOfProfiles =
	// 	reservation?.AdultCount +
	// 	reservation?.ChildCount -
	// 	(numOfKnownProfiles - undoneProfiles?.length);

	const [setNullProfileID, setSetNullProfileID, setNullProfileIDRef] =
		useState(false);
	const [_, setCurrentProfileIndex, currentProfileIndexRef] = useState(0);
	const [__, setCurrentStep, currentStepRef] = useState('');
	const [___, setDocuSubmissionSkipped, docuSubmissionSkipped] =
		useState(false);
	const [____, setLoaderModel, loaderModel] = useState(false);
	const enableVerification = settings?.find(
		(setting: any) =>
			setting.parameterName === 'EnableVerification' &&
			setting.parameterValue === 'true'
	);
	const enableDocSubmission = settings?.find(
		(setting: any) =>
			setting.parameterName === 'EnableDocSubmission' &&
			setting.parameterValue === 'false'
	);
	const [_____, setProfileModel, profileModel] = useState({});
	/* eslint-disable no-debugger */
	// debugger;
	/* eslint-enable no-debugger */
	// console.log(
	// 	settings?.map((item: any) => {
	// 		console.log('parameterName==##' + item.parameterName);
	// 	})
	// );

	useEffect(() => {
		setLoaderModel(false);
		// alert(currentStepRef?.current);
		// if (enableDocSubmission) {
		// 	setCurrentStep('documentVerification');
		// } else {
		// 	setCurrentStep('documentUpload');
		// }
		// setCurrentStep(currentStepRef?.current);
	}, []);

	useEffect(() => {
		/* eslint-disable no-debugger */
		// debugger;
		/* eslint-enable no-debugger */
		// alert(currentProfileIndexRef?.current + ',' + totalNumOfProfiles);
		if (
			(currentProfileIndexRef.current === totalNumOfProfiles &&
				reservation?.PmsConfirmationNo) ||
			docuSubmissionSkipped.current
		) {
			dispatch(
				completeStage({
					token: token,
					stageID: currStage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			);
		} else {
			if (
				profiles !== null &&
				profiles !== undefined &&
				currentProfileIndexRef.current < profiles?.length
			) {
				dispatch(
					updateProfileID(
						setNullProfileIDRef.current
							? null
							: profiles[currentProfileIndexRef.current]?.profileID
					)
				);

				dispatch(
					fetchProfile({
						profiles: profiles,
						profileID: profiles[currentProfileIndexRef.current]?.profileID,
					})
				)
					.unwrap()
					.then((profile: any) => {
						/* eslint-disable no-debugger */
						// debugger;
						/* eslint-enable no-debugger */
						// setProfileModel(profile);
						dispatch(
							setCurrentProfile(profiles[currentProfileIndexRef.current])
						);
						if (
							(currentProfileIndexRef.current === totalNumOfProfiles &&
								reservation?.PmsConfirmationNo) ||
							docuSubmissionSkipped.current
						) {
							dispatch(
								completeStage({
									token: token,
									stageID: currStage?.stepID,
									ReservationID: reservation?.ReservationID,
									type: 'checkin',
									confirmationNo: reservation?.PmsConfirmationNo,
									stages: stages,
									propertyCode: propertyInfo?.propertyCode ?? '', //added new
								})
							);
						} else {
							setSetNullProfileID(
								currentProfileIndexRef?.current > numOfKnownProfiles
							);
							dispatch(documentClear());
							dispatch(profileClear());
							dispatch(resetProfilePostComplete());

							if (enableDocSubmission) {
								setCurrentStep('documentVerification');
							} else {
								if (
									currentStepRef?.current !== 'livenessCheck' &&
									currentStepRef?.current !== 'documentVerification'
								)
									setCurrentStep('documentUpload');
							}
						}
					});
			} else {
				// setProfileModel((prevState) => ({
				// 	firstName: '',
				// 	lastName: '',
				// }));
				dispatch(setCurrentProfile(null));
				setSetNullProfileID(
					currentProfileIndexRef?.current > numOfKnownProfiles
				);
				if (enableDocSubmission) {
					setCurrentStep('documentVerification');
				} else {
					if (
						currentStepRef?.current !== 'livenessCheck' &&
						currentStepRef?.current !== 'documentVerification'
					)
						setCurrentStep('documentUpload');
				}
				setDocuSubmissionSkipped(false);
				dispatch(documentClear());
				dispatch(profileClear());
				dispatch(resetProfilePostComplete());
			}
		}
	}, [
		currentProfileIndexRef?.current,
		setNullProfileID,
		JSON.stringify(profiles),
	]);

	const getProfile = () => {
		// alert(profiles?.length);

		if (currentProfileIndexRef.current < profiles?.length) {
			const profile = profiles[currentProfileIndexRef?.current];
			dispatch(setCurrentProfile(profile));
		} else {
			dispatch(setCurrentProfile(null));
		}
	};
	// useEffect(() => {
	// 	if (profile !== null && JSON.stringify(profile ?? '') !== '') {
	// 		if (
	// 			(currentProfileIndexRef.current === totalNumOfProfiles &&
	// 				reservation?.PmsConfirmationNo) ||
	// 			docuSubmissionSkipped.current
	// 		) {
	// 			dispatch(
	// 				completeStage({
	// 					token: token,
	// 					stageID: currStage?.stepID,
	// 					ReservationID: reservation?.ReservationID,
	// 					type: 'checkin',
	// 					confirmationNo: reservation?.PmsConfirmationNo,
	// 					stages: stages,
	// 					propertyCode: propertyInfo?.propertyCode ?? '', //added new
	// 				})
	// 			);
	// 		} else {
	// 			setSetNullProfileID(
	// 				currentProfileIndexRef?.current > numOfKnownProfiles
	// 			);

	// 			setDocuSubmissionSkipped(false);
	// 			dispatch(documentClear());
	// 			dispatch(profileClear());
	// 			dispatch(resetProfilePostComplete());
	// 		}
	// 	}
	// }, [
	// 	currentProfileIndexRef.current,
	// 	reservation?.PmsConfirmationNo,
	// 	JSON.stringify(profile),
	// ]);

	useEffect(() => {
		if (
			currentStepRef?.current === 'documentVerification' &&
			docuSubmissionSkipped.current
		) {
			setCurrentStep('documentVerification');
			setDocuSubmissionSkipped(true);
			dispatch(
				completeStage({
					token: token,
					stageID: currStage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			);
		}

		// if (
		// 	currentStepRef?.current === 'documentVerification' &&
		// 	docuSubmissionSkipped.current &&
		// 	currentProfileIndexRef.current + 1 === totalNumOfProfiles
		// ) {
		// 	setCurrentStep('documentVerification');
		// 	setDocuSubmissionSkipped(true);
		// 	dispatch(
		// 		completeStage({
		// 			token: token,
		// 			stageID: 2,
		// 			ReservationID: reservation?.ReservationID,
		// 			type: 'checkin',
		// 			confirmationNo: reservation?.PmsConfirmationNo,
		// 			stages: stages,
		// 		})
		// 	);
		// } else {
		// 	setCurrentStep('documentUpload');
		// 	setDocuSubmissionSkipped(true);
		// 	dispatch(
		// 		completeStage({
		// 			token: token,
		// 			stageID: 2,
		// 			ReservationID: reservation?.ReservationID,
		// 			type: 'checkin',
		// 			confirmationNo: reservation?.PmsConfirmationNo,
		// 			stages: stages,
		// 		})
		// 	);
		// }
	}, [docuSubmissionSkipped.current]);

	useEffect(() => {
		if (isDocumentPostComplete === true) {
			dispatch(displayToast(false));
			dispatch(resetDocumentPostComplete());

			console.log(enableVerification + '--enableVerification');
			/* eslint-disable no-debugger */
			//debugger;
			console.log('fetchIdFront--');
			/* eslint-enable no-debugger */
			if (documentError.submitDocument === null) {
				// setCurrentProfileIndex(currentProfileIndexRef?.current + 1);
				if (enableVerification) {
					if (
						enableChildScan &&
						reservation?.ChildCount > 0 &&
						currentProfileIndexRef.current >= reservation?.AdultCount
					) {
						setCurrentStep('documentVerification');
					} else {
						setCurrentStep('livenessCheck');
					}
				} else {
					setCurrentStep('documentVerification');
				}
			}
		}
	}, [isDocumentPostComplete]);

	useEffect(() => {
		if (isFaceVerificationComplete === true) {
			dispatch(displayToast(false));
			dispatch(resetFaceVerificationComplete());
			if (documentError.verifyFaceImage === null) {
				const component = document.getElementsByTagName('face-liveness')[0];
				if (component !== null && component !== undefined) {
					component.remove();
				}
				setCurrentStep('documentVerification');
			}
		}
	}, [isFaceVerificationComplete]);

	useEffect(() => {
		if (isFaceVerificationError === true) {
			handleLivenessError();
		}
	}, [isFaceVerificationError]);

	useEffect(() => {
		// const handlePassportDocument = async () => {
		// 	if (
		// 		docTypeDescription !== null &&
		// 		docTypeDescription !== '' &&
		// 		docTypeDescription !== 'Passport' &&
		// 		isUploadingPassport
		// 	) {
		// 		setSetNullProfileID(
		// 			currentProfileIndexRef?.current > numOfKnownProfiles
		// 		);
		// 		setCurrentStep('documentUpload');
		// 		setDocuSubmissionSkipped(false);
		// 		// Show the SweetAlert and wait for user interaction
		// 		await Swal.fire({
		// 			//title: 'Invalid Document',
		// 			text: 'The document uploaded does not match the required ID type. Please upload the correct document for ID verification.',
		// 			icon: 'error',
		// 		});
		// 		// After the user interaction, reload the page
		// 		window.location.reload();
		// 	} else if (
		// 		docTypeDescription !== null &&
		// 		docTypeDescription !== '' &&
		// 		docTypeDescription !== 'Resident Identity Card' &&
		// 		!isUploadingPassport
		// 	) {
		// 		setSetNullProfileID(
		// 			currentProfileIndexRef?.current > numOfKnownProfiles
		// 		);
		// 		setCurrentStep('documentUpload');
		// 		setDocuSubmissionSkipped(false);
		// 		console.log('2');
		// 		// Show the SweetAlert and wait for user interaction
		// 		await Swal.fire({
		// 			//title: 'Invalid Document',
		// 			text: 'The document uploaded does not match the required ID type. Please upload the correct document for ID verification.',
		// 			icon: 'error',
		// 		});
		// 		// After the user interaction, reload the page
		// 		window.location.reload();
		// 	}
		// };
		// handlePassportDocument();
	}, [
		docTypeDescription,
		currentProfileIndexRef.current,
		reservation?.PmsConfirmationNo,
		isUploadingPassport,
	]);

	useEffect(() => {
		if (isProfilePostComplete === true) {
			dispatch(resetProfilePostComplete());
			dispatch(displayToast(false));
			setCurrentProfileIndex(currentProfileIndexRef?.current + 1);
			getProfile();
		}
	}, [isProfilePostComplete]);

	const handleDocumentUploadSubmission = () => {
		dispatch(displayToast(true));
	};

	const handleLivenessChecked = (image: any) => {
		// dispatch(post to see if the 2 transactionGUIDs match)
		// if yes, proceed to documentVerification
		// if no, restart livenessVerification or do nothing
		//console.log(guid, image);
		// setLoaderModel(true);
		dispatch(
			verifyFaceImage({
				token: token,
				image: image,
				transactionGUID: guid,
			})
		);
		setCurrentStep('');
		dispatch(displayToast(true));
	};
	const handleLivenessError = () => {
		// alert('handleLivenessError livenessCheck');
		setCurrentStep('');
		setCurrentStep('livenessCheck');
	};

	const handleDocumentVerification = () => {
		setCurrentStep('');
		dispatch(displayToast(true));
	};

	useEffect(() => {
		if (token && !propertyInfo) {
			dispatch(fetchPropertyInfo(token));
		}
	}, [token, JSON.stringify(propertyInfo)]);

	return (
		<>
			<div
				className="scrollable-content"
				// style={{
				// 	overflowY: 'auto',
				// 	maxHeight: 'calc(100vh - 80px)',
				// }}
			>
				{currentStepRef?.current === '' && (
					<>
						<Loading />{' '}
					</>
				)}
				{currentStepRef?.current === 'documentUpload' && (
					<div
						className="d-flex flex-column justify-content-center align-items-center w-100 theme-header"
						style={{ background: '#03355C', minHeight: '80px' }}>
						<p className="fs-2 m-0">{t('DocuScanPageHeader')}</p>
					</div>
				)}

				{currentStepRef?.current === 'livenessCheck' && (
					<div
						className="w-100 px-4 d-flex flex-row text-white justify-content-between align-items-center theme-header"
						style={{ backgroundColor: '#03355C', minHeight: '80px' }}>
						{enableDocSubmission === null ||
							(enableDocSubmission === undefined && (
								<FontAwesomeIcon
									icon={faChevronLeft}
									className="fs-2"
									style={{ cursor: 'pointer' }}
									onClick={() => {
										const component =
											document.getElementsByTagName('face-liveness')[0];
										component.remove();
										dispatch(ImageClear());
										dispatch(popDocumentNumber());
										setDocuSubmissionSkipped(false);
										setCurrentStep('documentUpload');
									}}
								/>
							))}

						<p className="text-center flex-grow-1 px-5 fs-2 m-0">
							{t('FacialPageHeader')}
						</p>
					</div>
				)}

				{currentStepRef?.current === 'documentVerification' &&
					!docuSubmissionSkipped.current && (
						<div
							className="w-100 px-4 d-flex flex-row text-white justify-content-between align-items-center theme-header"
							style={{ backgroundColor: '#03355C', height: '80px' }}>
							{enableDocSubmission === null ||
								(enableDocSubmission === undefined && (
									<FontAwesomeIcon
										icon={faChevronLeft}
										style={{ color: 'white', cursor: 'pointer' }}
										className="fs-2"
										onClick={() => {
											dispatch(ImageClear());
											dispatch(popDocumentNumber());
											if (docuSubmissionSkipped.current) {
												setDocuSubmissionSkipped(false);
												setCurrentStep('documentUpload');
											} else {
												setCurrentStep('documentUpload');
											}
										}}
									/>
								))}

							<>
								{/* {propertyInfo?.propertyCode == 'YAM' ||
								process.env.REACT_APP_THEME == 'YAM' ? ( */}
								<div className="d-flex flex-column justify-content-center align-items-center w-100 theme-header">
									<p className="flex-grow-1 px-5 fs-2 m-0">
										{t('RegFormHeader')}
									</p>
									<span className="theme-subtitle">
										{t('RegFormSubHeader')}
									</span>
								</div>
								{/* ) : (
									<>
										{enableChildScan !== null &&
										reservation?.ChildCount > 0 &&
										currentProfileIndexRef.current >=
											reservation?.AdultCount ? (
											<>Child Details</>
										) : currentProfileIndexRef.current > 0 ? (
											<>Accompany Guest Details</>
										) : (
											<>Primary Guest Details</>
										)}
									</>
								)} */}
							</>
						</div>
					)}
				{currentStepRef?.current === 'documentUpload' ? (
					<>
						{console.log('came to documentUpload')}
						<DocuSubmissionHome
							callback={handleDocumentUploadSubmission}
							skipDocuSubmission={() => {
								// toast.info('Verification needs to be done in Hotel');
								setDocuSubmissionSkipped(true);
								setCurrentStep('documentVerification');
							}}
							numberOfProfilesToCheckIn={totalNumOfProfiles}
							currentProfileIndex={currentProfileIndexRef?.current + 1}
							adultCount={reservation?.AdultCount}
							childCount={enableChildScan ? reservation?.ChildCount : 0}
						/>
					</>
				) : currentStepRef?.current === 'livenessCheck' ? (
					<LivenessVerificationHome
						callback={handleLivenessChecked}
						loaderModel={loaderModel.current}
						skipLiveness={() => {
							const component =
								document.getElementsByTagName('face-liveness')[0];
							component.remove();
							// toast.info('Verification needs to be done in Hotel');
							setCurrentStep('documentVerification');
							dispatch(clearError());
							dispatch(clearDocumentError());
							// dispatch(displayToast(false));
						}}
						onError={handleLivenessError}
					/>
				) : currentStepRef?.current === 'documentVerification' &&
				  !docuSubmissionSkipped.current ? (
					<GuestProfileFormHome
						callback={handleDocumentVerification}
						docuSubmissionSkipped={docuSubmissionSkipped}
						currentProfileIndex={currentProfileIndexRef?.current}
						currentProfile1={currentProfile}
						guid={guid}
					/>
				) : currentStepRef?.current === 'documentVerification' &&
				  docuSubmissionSkipped.current ? (
					<></>
				) : currentStepRef?.current === 'documentVerification' &&
				  !docuSubmissionSkipped.current &&
				  currentProfileIndexRef?.current !== totalNumOfProfiles ? (
					<GuestProfileFormHome
						callback={handleDocumentVerification}
						docuSubmissionSkipped={docuSubmissionSkipped}
						currentProfileIndex={currentProfileIndexRef?.current}
						currentProfile1={getProfile()}
						guid={guid}
					/>
				) : (
					<></>
				)}
			</div>
		</>
	);
};
